module.exports = __webpack_public_path__ + "img/PortfolioManager.bfa4abd5.png";